import { clone, without } from 'ramda'
import { readSettingsFromCookies, writeUserSettings } from './util/userSettings'
import { executeCookieOptins } from './util/cookie'
import EventBus from './util/EventBus'


export const EVENT_SHOW_LAYER = 'showLayer'
export const EVENT_CHANGE_LOCALE = 'changeLocale'
export const EVENT_LOAD_LAYER = 'load'
export const EVENT_UPDATE_LAYER = 'update'
export const EVENT_CLOSE_LAYER = 'closeLayer'

const createConsentState = () => {
    /**
     * The current user selection that is stored in the cookie.
     *
     * @sig [String]
     */
    let _acceptedIds = []

    const showLayer = config => EventBus.$emit(EVENT_SHOW_LAYER, config)

    const changeLocale = locale => EventBus.$emit(EVENT_CHANGE_LOCALE, { locale })

    const $on = (eventName, cb) => EventBus.$on(eventName, cb)

    const $off = eventName => EventBus.$off(eventName)

    // isAccepted :: String -> Boolean
    const isAccepted = id => _acceptedIds.includes(id)

    // setAccepted :: [String] -> *
    const setAccepted = (arr) => {
        _acceptedIds = clone(arr)
    }

    // read :: Obj -> { acceptedCookies: [String], isNew: Boolean, needsRefresh: Boolean }
    const read = (cookieConfig) => {
        const obj = readSettingsFromCookies(cookieConfig)
        setAccepted(obj.acceptedCookies)

        executeCookieOptins(cookieConfig, obj.acceptedCookies)
        EventBus.$emit(EVENT_LOAD_LAYER, { accepted: clone(_acceptedIds) })

        return obj
    }

    // write :: Obj -> [String] -> undefined
    const write = (cookieConfig, acceptedIds) => {
        const added = without(_acceptedIds, acceptedIds)
        const removed = without(acceptedIds, _acceptedIds)
        const event = { added, removed, accepted: clone(acceptedIds) }

        writeUserSettings(cookieConfig, acceptedIds)
        setAccepted(acceptedIds)

        executeCookieOptins(cookieConfig, acceptedIds)
        EventBus.$emit(EVENT_UPDATE_LAYER, event)
        EventBus.$emit(EVENT_CLOSE_LAYER)

        return event
    }

    return {
        read,
        write,
        changeLocale,
        isAccepted,
        showLayer,
        $on,
        $off,
    }
}

export default createConsentState()
